"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const DATE_FORMAT = 'DD-MM-YYYY';
exports.DATE_FORMAT = DATE_FORMAT;
const TIME_FORMAT = 'HH:mm';
exports.TIME_FORMAT = TIME_FORMAT;
const DATE_TIME_FORMAT = `${DATE_FORMAT}, ${TIME_FORMAT}`;
exports.DATE_TIME_FORMAT = DATE_TIME_FORMAT;
const RANGE_HOUR = 'hour';
exports.RANGE_HOUR = RANGE_HOUR;
const RANGE_DAY = 'day';
exports.RANGE_DAY = RANGE_DAY;
const RANGE_WEEK = 'week';
exports.RANGE_WEEK = RANGE_WEEK;
const RANGE_MONTH = 'month';
exports.RANGE_MONTH = RANGE_MONTH;
const RANGE_QUARTER = 'quarter';
exports.RANGE_QUARTER = RANGE_QUARTER;
const RANGE_YEAR = 'year';
exports.RANGE_YEAR = RANGE_YEAR;
const RANGE_HOUR_FORMAT = 'HH:mm';
exports.RANGE_HOUR_FORMAT = RANGE_HOUR_FORMAT;
const RANGE_DAY_FORMAT = 'DD/MM';
exports.RANGE_DAY_FORMAT = RANGE_DAY_FORMAT;
const RANGE_WEEK_FORMAT = RANGE_DAY_FORMAT;
exports.RANGE_WEEK_FORMAT = RANGE_WEEK_FORMAT;
const RANGE_MONTH_FORMAT = 'MM/YYYY';
exports.RANGE_MONTH_FORMAT = RANGE_MONTH_FORMAT;
const RANGE_QUARTER_FORMAT = RANGE_MONTH_FORMAT;
exports.RANGE_QUARTER_FORMAT = RANGE_QUARTER_FORMAT;
const RANGE_YEAR_FORMAT = 'YYYY';
exports.RANGE_YEAR_FORMAT = RANGE_YEAR_FORMAT;
const format = (date, dateFormat = DATE_TIME_FORMAT) => !date ? '-' : moment_1.default(date).format(dateFormat);
exports.format = format;
const formatRange = (date, range) => {
    switch (range) {
        case RANGE_HOUR:
            return moment_1.default(date).format(RANGE_HOUR_FORMAT);
        case RANGE_DAY:
            return moment_1.default(date).format(RANGE_DAY_FORMAT);
        case RANGE_WEEK:
            return `${moment_1.default(date).format(RANGE_WEEK_FORMAT)} -> ${moment_1.default(date)
                .add(6, 'days')
                .format(RANGE_WEEK_FORMAT)}`;
        case RANGE_MONTH:
            return moment_1.default(date).format(RANGE_MONTH_FORMAT);
        case RANGE_QUARTER:
            return `${moment_1.default(date).format(RANGE_QUARTER_FORMAT)} -> ${moment_1.default(date)
                .add(2, 'months')
                .format(RANGE_QUARTER_FORMAT)}`;
        case RANGE_YEAR:
            return moment_1.default(date).format(RANGE_YEAR_FORMAT);
        default:
            return null;
    }
};
exports.formatRange = formatRange;
const getRanges = (date) => {
    const result = { date: '', week: '', month: '', quarter: '', year: '' };
    result.date = format(date, DATE_FORMAT);
    result.week = formatRange(moment_1.default(date).startOf('week'), 'week');
    result.month = formatRange(date, 'month');
    result.quarter = formatRange(moment_1.default(date).startOf('quarter'), 'quarter');
    result.year = formatRange(date, 'year');
    return result;
};
exports.getRanges = getRanges;
//# sourceMappingURL=formatDate.js.map